(function () {
  const STORAGE_KEY = 'customProducts';

  function safeParse(json) {
    try { return JSON.parse(json); } catch (e) { return null; }
  }

  function read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return Array.isArray(safeParse(raw)) ? safeParse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr || []));
    } catch (e) {
      // Safariのプライベートブラウズ等で失敗する場合あり
    }
  }

  function count() {
    return read().length;
  }

  function updateFloatingCount() {
    const el = document.getElementById('js-custom-count');
    if (el) el.textContent = String(count());
    updateFloatingLinkByCount();
  }

  function updateFloatingLinkByCount() {
    const floating = document.getElementById('custom-floating');
    if (!floating) return;

    const link = floating.querySelector('.custom-floating__link');
    const text = floating.querySelector('.custom-floating__text');
    if (!link || !text) return;

    // 元の状態を一度だけ保持（count が戻った時に復元するため）
    if (!link.dataset.origHref) link.dataset.origHref = link.getAttribute('href') || '';
    if (!text.dataset.origText) text.dataset.origText = text.textContent || '';

    const c = count();
    floating.classList.toggle('is_item', c >= 1);

    if (count() === 0) {
      link.setAttribute('href', '/collections/custom');
      text.textContent = 'カスタム商品を選ぶ';
    } else {
      link.setAttribute('href', link.dataset.origHref);
      text.textContent = text.dataset.origText;
    }
  }

  function getCurrentVariantId(startEl) {
    // もっとも近い /cart/add フォームの name="id" の値（セレクト/hidden）を取得
    const form = (startEl && startEl.closest && startEl.closest('form[action*="/cart/add"]')) ||
                 document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    const input = form.querySelector('[name="id"]');
    if (!input) return null;
    return input.value ? String(input.value) : null;
  }

  function escapeHtml(str) {
    if (typeof str !== 'string') return str;
    return str.replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#039;' }[m]));
  }

  function deriveHandleFromUrl(url) {
    if (!url) return '';
    try {
      var m = url.match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function buildItemFromButton(btn) {
    const d = btn.dataset;
    const variantId = getCurrentVariantId(btn) || d.defaultVariantId || null;
    const productId = d.productId || '';
    const key = variantId ? `${productId}:${variantId}` : `${productId}`;

    return {
      key: key,
      productId: productId,
      variantId: variantId,
      handle: d.handle || deriveHandleFromUrl(d.url || ''),
      title: d.title || '',
      url: d.url ? (variantId ? `${d.url}?variant=${variantId}` : d.url) : '',
      image: d.image || '',
      imageAlt: d.imageAlt || '',
      price: d.priceString || '',
      sku: d.sku || '',
      addedAt: Date.now()
    };
  }

  // NEW: 既存 localStorage の item に handle を補完
  function upgradeStorageForHandle() {
    const list = read();
    let changed = false;
    for (let i = 0; i < list.length; i++) {
      const it = list[i];
      if (!it.handle) {
        const h = deriveHandleFromUrl(it.url || '');
        if (h) { it.handle = h; changed = true; }
      }
    }
    if (changed) write(list);
  }

// どこか初期化のタイミング（例：DOMContentLoaded）で一度実行
document.addEventListener('DOMContentLoaded', upgradeStorageForHandle);

  function addCurrent(btn) {
    const list = read();
    const item = buildItemFromButton(btn);

    if (!list.some(i => i.key === item.key)) {
      list.push(item);
      write(list);
      updateFloatingCount();
      const fb = document.getElementById('js-custom-add-feedback');
      if (fb) { fb.hidden = false; fb.textContent = '追加しました'; setTimeout(() => fb.hidden = true, 1500); }
    } else {
      const fb = document.getElementById('js-custom-add-feedback');
      if (fb) { fb.hidden = false; fb.textContent = 'すでに追加済みです'; setTimeout(() => fb.hidden = true, 1500); }
    }
  }

  function remove(key) {
    const next = read().filter(i => i.key !== key);
    write(next);
    updateFloatingCount();
  }

  function renderList(containerSelector) {
    const container = typeof containerSelector === 'string'
      ? document.querySelector(containerSelector)
      : containerSelector;

    if (!container) return;

    const list = read();
    const empty = document.getElementById('js-custom-empty');

    if (!list.length) {
      container.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    } else {
      if (empty) empty.hidden = true;
    }

    const html = list.map(i => `
      <li class="custom-list-item" data-item data-key="${i.key}">
        <a href="${i.url}" class="custom-list-item__image" aria-label="${escapeHtml(i.title)}">
          <img src="${i.image}" alt="${escapeHtml(i.imageAlt || i.title)}" loading="lazy">
        </a>
        <div class="custom-list-item__content">
          <a href="${i.url}" class="custom-list-item__title">${escapeHtml(i.title)}</a>
          ${i.price ? `<div class="custom-list-item__price">${escapeHtml(i.price)}</div>` : ''}
        </div>
        <button type="button" class="custom-list-item__remove" data-remove-key="${i.key}" aria-label="この商品を削除">✕</button>
      </li>
    `).join('');

    container.innerHTML = html;
  }

  // 公開API（一覧テンプレートから呼びます）
  window.CustomList = { read, write, count, addCurrent, remove, renderList, updateFloatingCount };

  // クリック監視（追加・削除）
  document.addEventListener('click', function (e) {
    const addBtn = e.target.closest && e.target.closest('#js-custom-add-btn');
    if (addBtn) {
      e.preventDefault();
      addCurrent(addBtn);
      return;
    }
    const rmBtn = e.target.closest && e.target.closest('[data-remove-key]');
    if (rmBtn) {
      e.preventDefault();
      const key = rmBtn.getAttribute('data-remove-key');
      remove(key);
      const itemEl = rmBtn.closest('[data-item]');
      if (itemEl) itemEl.remove();

      // 空になったら空表示
      const listEl = document.querySelector('#js-custom-list');
      if (listEl && listEl.children.length === 0) {
        const empty = document.getElementById('js-custom-empty');
        if (empty) empty.hidden = false;
      }
    }
  });

  // バッジ初期化と他タブ同期
  document.addEventListener('DOMContentLoaded', updateFloatingCount);
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) updateFloatingCount();
  });
})();
